exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inputfile[data-v-4b1c62e7]{width:.1px;height:.1px;opacity:0;overflow:hidden;position:absolute;z-index:-1}#file_loader[data-v-4b1c62e7]{margin:0 0 0 1%;padding:0;cursor:pointer}.hand[data-v-4b1c62e7]{cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4b1c62e7","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/Quality2.vue
// module id = 320
// module chunks = 0